import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../constants';

@Injectable()
export class LogsArchivingService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http: Http) { }

  getLogs(periodo, orderby, sort, page, qtd) {

    const skip = qtd * page;

    return this.http
      // tslint:disable-next-line: max-line-length
      .post(this.apiUrl + "bucket/v1/getlogsamazon?$orderby=" + orderby + " " + sort + "&$top=" + qtd + "&$skip=" + skip, periodo, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  // Request para download dos arquivos
  downloadAttachment(fileName) {
    // const data = {
    //   objectKey: fileName
    // };
    const localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'));
    const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });

    return this.http
      // tslint:disable-next-line: max-line-length
      .get(this.apiUrl + "bucket/v1/downloadlogsamazon?objectKey=" + fileName, options)
      .map(res => {
        return new Blob([res.blob()], { type: "application/octet-stream" });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/logs-archiving/logs-archiving.service.ts